import { render } from "./oneImageInfoShow.vue?vue&type=template&id=6095c7d2&scoped=true"
import script from "./oneImageInfoShow.vue?vue&type=script&lang=js"
export * from "./oneImageInfoShow.vue?vue&type=script&lang=js"

import "./oneImageInfoShow.vue?vue&type=style&index=0&id=6095c7d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6095c7d2"

export default script